import c from "./ghl-ui.es1589.js";
import m from "./ghl-ui.es1590.js";
import n from "./ghl-ui.es1586.js";
import f from "./ghl-ui.es1587.js";
import u from "./ghl-ui.es1588.js";
import s from "./ghl-ui.es1591.js";
import { Parser as h } from "./ghl-ui.es1670.js";
import { mapValue as v, parseNDigits as g } from "./ghl-ui.es1671.js";
var k = /* @__PURE__ */ function(l) {
  f(o, l);
  var i = u(o);
  function o() {
    var e;
    c(this, o);
    for (var t = arguments.length, a = new Array(t), r = 0; r < t; r++)
      a[r] = arguments[r];
    return e = i.call.apply(i, [this].concat(a)), s(n(e), "priority", 30), s(n(e), "incompatibleTokens", ["t", "T"]), e;
  }
  return m(o, [{
    key: "parse",
    value: function(t, a) {
      var r = function(p) {
        return Math.floor(p * Math.pow(10, -a.length + 3));
      };
      return v(g(a.length, t), r);
    }
  }, {
    key: "set",
    value: function(t, a, r) {
      return t.setUTCMilliseconds(r), t;
    }
  }]), o;
}(h);
export {
  k as FractionOfSecondParser
};
